import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';
import {Footer} from '../../components';
import {
  redirectToDocumentTime,
  redirectToTakePhotoDocument,
} from '../../ducks/Navigate';

import './styles.scss';

class DocumentVerse extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(RouteKeys.DocumentVerse.title);
  }

  render = () => (
    <div className="div-document-verse">
      <div className="content">
        <form id="frm">
          <div className="title">
            <p>Perfeito!</p>
            <div className="title-green">
              <p>Agora o outro lado.</p>
            </div>
          </div>

          <div className="document-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 159.57 251.8">
              <g id="Layer_2" data-name="Layer 2">
                <g id="Content">
                  <rect
                    className="cls-1"
                    x="1.39"
                    y="1.39"
                    width="156.8"
                    height="249.03"
                    rx="9.22"
                  />
                  <line
                    className="cls-1"
                    x1="53.84"
                    y1="228.62"
                    x2="53.84"
                    y2="24.44"
                  />
                  <line
                    className="cls-1"
                    x1="95.26"
                    y1="228.62"
                    x2="95.26"
                    y2="64.61"
                  />
                  <line
                    className="cls-1"
                    x1="112.07"
                    y1="228.62"
                    x2="112.07"
                    y2="66.59"
                  />
                  <line
                    className="cls-1"
                    x1="128.87"
                    y1="228.62"
                    x2="128.87"
                    y2="66.59"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,135.14a4.61,4.61,0,1,1-4.61,4.61A4.61,4.61,0,0,1,75.17,135.14Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,121.3a4.62,4.62,0,1,1-4.61,4.62A4.62,4.62,0,0,1,75.17,121.3Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,107.47a4.61,4.61,0,1,1-4.61,4.61A4.62,4.62,0,0,1,75.17,107.47Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,93.63a4.62,4.62,0,1,1-4.61,4.62A4.62,4.62,0,0,1,75.17,93.63Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,79.8a4.61,4.61,0,1,1-4.61,4.61A4.62,4.62,0,0,1,75.17,79.8Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,66a4.62,4.62,0,1,1-4.61,4.62A4.62,4.62,0,0,1,75.17,66Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,24.46a4.61,4.61,0,1,1-4.61,4.61A4.61,4.61,0,0,1,75.17,24.46Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,38.29a4.62,4.62,0,1,1-4.61,4.62A4.62,4.62,0,0,1,75.17,38.29Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,52.13a4.61,4.61,0,1,1-4.61,4.61A4.62,4.62,0,0,1,75.17,52.13Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,218.12a4.62,4.62,0,1,1-4.61,4.61A4.62,4.62,0,0,1,75.17,218.12Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,204.29a4.61,4.61,0,1,1-4.61,4.61A4.61,4.61,0,0,1,75.17,204.29Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,190.45a4.62,4.62,0,1,1-4.61,4.61A4.62,4.62,0,0,1,75.17,190.45Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,176.62a4.61,4.61,0,1,1-4.61,4.61A4.61,4.61,0,0,1,75.17,176.62Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,162.78a4.62,4.62,0,1,1-4.61,4.61A4.62,4.62,0,0,1,75.17,162.78Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,149a4.61,4.61,0,1,1-4.61,4.61A4.61,4.61,0,0,1,75.17,149Z"
                  />
                  <path
                    className="cls-2"
                    d="M75.17,135.11a4.62,4.62,0,1,1-4.61,4.61A4.62,4.62,0,0,1,75.17,135.11Z"
                  />
                  <polyline
                    className="cls-1"
                    points="38.47 227.36 19.64 227.36 19.64 24.45 38.47 24.45 38.47 227.36"
                  />
                </g>
              </g>
            </svg>
          </div>
          <div className="instructions">
            <p>Centralize o documento na marca.</p>
          </div>
        </form>
      </div>
      <div class="footer-container">
        <Footer
          backHandle={() => {
            this.props.redirectToTakePhotoDocument(false);
          }}
          nextHandle={() => this.props.redirectToTakePhotoDocument(true)}
        />
      </div>
    </div>
  );
}

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, {
  redirectToDocumentTime,
  redirectToTakePhotoDocument,
})(DocumentVerse);
